import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import Logo from '../../../img/logotipoComercam.svg';
import estilos from './CredencialComponent.module.css'

function CredencialComponent(props) {


    const programacion = [
        {
            id: 1, estado: 'Cordova', fechaInicio: '02/05/2022', fechaFin: '03/05/2022'
        }
        ,
        {
            id: 2, estado: 'Puebla', fechaInicio: '02/05/2022', fechaFin: '02/05/2022'
        },
        {
            id: 3, estado: 'Guerrero', fechaInicio: '02/05/2022', fechaFin: '03/05/2022'
        },
        {
            id: 4, estado: 'CDMX', fechaInicio: '02/05/2022', fechaFin: '03/05/2022'
        },
        {
            id: 5, estado: 'Puebla', fechaInicio: '02/05/2022', fechaFin: '03/05/2022'
        }
        ,
        {
            id: 6, estado: 'Puebla', fechaInicio: '02/05/2022', fechaFin: '03/05/2022'
        }
    ]

    return (
        <Fragment><br />
            <div className='container'>
                <div className='row'>
                    <div className={`col-6 mt-4 ${estilos.titular}`}>
                        CONSEJO MEXICANO REGULADOR <br></br>
                        DE LA CALIDAD DEL MEZCAL, A.C <hr></hr>
                        UNIDAD DE INSPECCIÓN
                    </div>
                    <div className='col-6' style={{ textAlign: 'right', paddingRight: '10%' }}>

                        <img src={Logo} width='150px' />

                    </div>

                </div>
                <div className='row text-center'>
                    <strong>PROGRAMACIÓN DE VISITAS DE INSPECCIÓN 2022</strong><br></br><br></br>
                </div>
                <div className='row'>
                    <div className='col-4'>
                        <img src={props.inspector.imagen} className='img-fluid' width={400} />
                    </div>

                    <div className='col-4 mt-5'>
                        <strong> INSPECTOR</strong><br></br>
                        Nombre:<br></br><p className={`${estilos.titular}`}>{props.inspector.nombre} {props.inspector.apellidos}</p>
                        Celular:<p className={`${estilos.titular}`}>9511101101</p>
                        Área:<p className={`${estilos.titular}`}>Unidad de Inspección</p>
                        Tutor: <p className={`${estilos.titular}`}>{props.inspector.tutor}</p>
                        Estatus: <p className={`${estilos.titular}`}>{props.inspector.estatus}</p>

                    </div>
                    <div className='col-4'>
                        <table className='table text-center'>
                            <thead>
                                <tr>
                                    <td className={`${estilos.td}`}>ESTADO</td>
                                    <td className={`${estilos.td}`}>DÍAS</td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    programacion.map((pro, index) => (
                                        <tr className='text-center'>
                                            <td >{pro.estado}</td>
                                            <td>del {pro.fechaInicio} al {pro.fechaFin} </td>
                                        </tr>
                                    ))
                                }

                            </tbody>

                        </table>
                    </div>

                </div>
                <br></br>



            </div>



        </Fragment>
    );
};


export default withRouter(CredencialComponent)
